<!-- /src/components/connect/connect.vue -->


<template>
  <wx-open-launch-weapp id="launch-btn" username="原始ID" path="赋值自己的path页面">
    <template>
      <button class="btn">跳转小程序</button>
    </template>
  </wx-open-launch-weapp>
</template>

<script>

export default {
  data() {
    return {
      appId: null,
      nonceStr: null,
      timestamp: null,
      signature: null
    }
  },

}
;
</script>

<style scoped>
/* 样式可以根据需要添加或修改 */
</style>



// WEBPACK FOOTER //
// src/components/connect/connect.vue